import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    class: "logout-page",
    "data-testid": "session-ended-view"
};
const _hoisted_2 = {
    class: "w-full max-w-[525px] flex flex-col px-4 sm:px-6",
    "aria-labelledby": "logout-title"
};
const _hoisted_3 = { class: "flex flex-col gap-3 sm:gap-5 text-left mb-8 sm:mb-12" };
const _hoisted_4 = {
    id: "logout-title",
    "data-testid": "session-ended-title",
    class: "title-text"
};
const _hoisted_5 = { class: "subtitle-text" };
const _hoisted_6 = ["aria-label"];
const _hoisted_7 = ["disabled", "aria-label", "aria-busy"];
const _hoisted_8 = {
    key: 0,
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "aria-hidden": "true",
    focusable: "false"
};
import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { keycloakAuthService } from "@/infrastructure/adapters/KeycloakAuthService";
import { logger } from "@/infrastructure/services/LoggerService";
export default /*@__PURE__*/ _defineComponent({
    __name: 'Logout',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const isLoggingIn = ref(false);
        const REASON_KEYS = {
            "no-org": {
                title: "logout.noOrganizationAccess.title",
                body: "logout.noOrganizationAccess.body",
            },
            "wrong-org": { title: "logout.wrongOrganization.title", body: "logout.wrongOrganization.body" },
        };
        const reasonKeys = computed(() => REASON_KEYS[String(route.query.reason)]);
        const titleKey = computed(() => reasonKeys.value?.title ?? "logout.title");
        const subtitleKey = computed(() => reasonKeys.value?.body ?? "logout.subtitle");
        onMounted(() => {
            if (keycloakAuthService.isAuthenticated()) {
                logger.debug("User is already authenticated, redirecting to home");
                router.push("/");
            }
            const checkAuth = () => {
                if (keycloakAuthService.isAuthenticated()) {
                    logger.debug("User became authenticated, redirecting to home");
                    router.push("/");
                }
            };
            const interval = setInterval(checkAuth, 1000);
            // Cleanup on unmount
            return () => clearInterval(interval);
        });
        const handleLogin = async () => {
            if (isLoggingIn.value)
                return;
            isLoggingIn.value = true;
            try {
                sessionStorage.removeItem("force-logout");
                sessionStorage.removeItem("auth-redirect-path");
                sessionStorage.setItem("auth-redirect-path", "/");
                await keycloakAuthService.login({
                    redirectUri: window.location.origin + "/",
                });
                setTimeout(() => {
                    if (keycloakAuthService.isAuthenticated()) {
                        router.push("/");
                    }
                }, 1000);
            }
            catch (error) {
                logger.debug("Login failed:", error);
                isLoggingIn.value = false;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", {
                        class: "logo-text mb-6 sm:mb-8",
                        role: "img",
                        "aria-label": "EUDONET"
                    }, " EUDONET ", -1 /* CACHED */)),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t(titleKey.value)), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(subtitleKey.value)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("nav", {
                        class: "buttons-container",
                        role: "navigation",
                        "aria-label": _ctx.$t('logout.actionsLabel')
                    }, [
                        _createElementVNode("button", {
                            type: "button",
                            "data-testid": "session-ended-reconnect",
                            disabled: isLoggingIn.value,
                            class: "btn-primary",
                            "aria-label": isLoggingIn.value ? _ctx.$t('login.loggingIn') : _ctx.$t('logout.reconnect'),
                            "aria-busy": isLoggingIn.value,
                            onClick: handleLogin
                        }, [
                            _createElementVNode("span", null, _toDisplayString(isLoggingIn.value ? _ctx.$t("login.loggingIn") : _ctx.$t("logout.reconnect")), 1 /* TEXT */),
                            (!isLoggingIn.value)
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                                        _createElementVNode("path", { d: "M5 12h14" }, null, -1 /* CACHED */),
                                        _createElementVNode("path", { d: "m12 5 7 7-7 7" }, null, -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true)
                        ], 8 /* PROPS */, _hoisted_7)
                    ], 8 /* PROPS */, _hoisted_6)
                ])
            ]));
        };
    }
});
